import React from "react"
import { getPlayerRating } from "../functions/players"
function Stars(props){
  return (
    <div className="stars" style={{"--rating": getPlayerRating(props.player) / 20 } }></div>
  )
}
export default Stars
